(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('NewTagController', NewTagController);

    NewTagController.$inject = ['$state', '$uibModalInstance', 'TestSettingTag', 'AlertService'];

    function NewTagController($state, $uibModalInstance, TestSettingTag, AlertService) {
        var vm = this;
        vm.tag = {isCrossDomain: false};

        vm.clear = function () {
            // $uibModalInstance.dismiss('cancel');
            $uibModalInstance.close();
        };

        vm.save = function () {

            var body = {
                testTag: vm.tag.name,
                crossDomain: vm.tag.isCrossDomain
            };
            TestSettingTag.create(body, onSuccess, onError);

            function onSuccess() {
                $uibModalInstance.close();
            }

            function onError() {
                AlertService.error("Tag already exist");
            }
        };

    }
})();
